import axios from 'axios';
import Cookies from 'js-cookie';

let baseURL = '';

// if (window.location.hostname === 'localhost') {
//   baseURL = '';
// } else {
//   const parts = window.location.hostname.split('.');
//   const subdomain = parts[0];
//   const domain = parts.slice(1).join('.');
//   baseURL = `https://${subdomain}.${domain}/api`;
// }

if (window.location.hostname !== 'localhost') {
  const parts = window.location.hostname.split('.');
  const subdomain = parts[0];
  const domain = parts.slice(1).join('.');
  baseURL = `https://${subdomain}.${domain}/api`;
}

const axiosInstance = axios.create({
  baseURL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    /* eslint-disable no-param-reassign */
    const token = Cookies.get('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
    /* eslint-enable no-param-reassign */
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default axiosInstance;
